export function isSessionConflictResponse(response: {
  errorCode?: string;
  errorMessage?: string;
  status?: number;
  error_description?: string;
}): boolean {
  return (
    response.status === 409 ||
    response.errorCode === '409' ||
    response.error_description === 'SessionInProgress'
  );
}

export function isSessionConflictError(error: unknown): boolean {
  const sdkError = error as {
    errorType?: string;
    data?: {
      status?: number;
      body?: { error_description?: string };
      error_description?: string;
    };
    message?: string;
  };

  const errorDescription =
    sdkError.data?.body?.error_description || sdkError.data?.error_description || '';

  return (
    (sdkError.errorType === 'CXONE_API_ERROR' && sdkError.data?.status === 409) ||
    errorDescription === 'SessionInProgress' ||
    sdkError.message?.includes('SessionInProgress') ||
    sdkError.message?.includes('409') ||
    false
  );
}

export function isInvalidSessionError(error: unknown): boolean {
  const sdkError = error as {
    data?: {
      body?: { error_description?: string };
      error_description?: string;
    };
    message?: string;
  };

  const errorDescription =
    sdkError.data?.body?.error_description || sdkError.data?.error_description || '';

  return (
    errorDescription === 'InvalidAgentSession' ||
    sdkError.message?.includes('InvalidAgentSession') ||
    false
  );
}
